import { BUILDER, DRAFT } from 'shared/abilities';
import { LANGUAGE_NAME_MAPPING } from 'shared/i18n';
import User from 'shared/user';
import {
  HOME_PAGE,
  MISC_PAGE,
  FACILITY_PAGE,
  FACILITY_LINK,
  FACILITY_LISTING,
  FACILITIES_LIST_PAGE,
  PRIVACY_PAGE,
  TERMS_PAGE,
  PAY_ONLINE_PAGE,
} from 'shared/pageTypes';

const checkForBuilder = ({ profile }) => {
  const user = new User(profile);
  return user.isAuthorized({
    action: 'manage',
    subject: [BUILDER, DRAFT],
    companyId: user.companyId,
  });
};

const applyRenderCondition = item => (item.renderCondition ? item.renderCondition() : true);

const renderFilters = (props) => {
  const languageOptions = props.nonDefaultLanguages.map(language => ({
    name: LANGUAGE_NAME_MAPPING[language.code],
    value: language.code,
    type: 'languages',
  }));

  const filters = [
    {
      name: 'Publish State',
      options: [
        {
          name: 'Live',
          value: 'live',
        },
        {
          name: 'Live (unpublished changes)',
          value: 'unpublished',
        },
        {
          name: 'Draft',
          value: 'draft',
          renderCondition: () => checkForBuilder(props),
        },
      ],
    },
    {
      name: 'Page Type',
      options: [
        {
          name: 'Home Page',
          value: HOME_PAGE,
          type: 'pageTypes',
        },
        {
          name: 'Facility Page',
          value: FACILITY_PAGE,
          type: 'pageTypes',
        },
        {
          name: 'Facility Link',
          value: FACILITY_LINK,
          type: 'pageTypes',
        },
        {
          name: 'Facility Listing',
          value: FACILITY_LISTING,
          type: 'pageTypes',
        },
        {
          name: 'Facility List Page',
          value: FACILITIES_LIST_PAGE,
          type: 'pageTypes',
        },
        {
          name: 'Privacy Page',
          value: PRIVACY_PAGE,
          type: 'pageTypes',
        },
        {
          name: 'Terms Page',
          value: TERMS_PAGE,
          type: 'pageTypes',
        },
        {
          name: 'Pay Online',
          value: PAY_ONLINE_PAGE,
          type: 'pageTypes',
        },
        {
          name: 'Misc Page',
          value: MISC_PAGE,
          type: 'pageTypes',
        },

      ],
    },
    {
      name: 'Language',
      renderCondition: () => props.languagesEnabled && languageOptions.length,
      options: languageOptions,
    },
  ];

  return filters.filter((filter) => {
    filter.options = filter.options.filter(applyRenderCondition);
    return applyRenderCondition(filter);
  });
};

export default renderFilters;
